import { prepareAuth } from '@/network/auth-policy'
import { handleExpiredSession } from '@/common/auth-navigation'
import axios from 'axios'
import store from 'store/index' ///导入公共仓库
import vm from '@/main'
import CONFIG from '@/config/config.js';

// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
////常规接口请求
///基础参数
let remoteBaseUrl = ''
const baseHeaders = { 'Content-Type': 'application/json' }


// 分环境打包  设置默认的http请求路径
console.log(process.env.NODE_ENV)
const env = process.env.VUE_APP_CURENV || 'dev';  // 或根据实际来源判断
remoteBaseUrl = (CONFIG.env[env] || CONFIG.env.dev).remoteBaseUrl;

console.log(remoteBaseUrl); // 打印当前环境对应的 baseUrl




const request = config => {
  //1,创建axios实例
  const instance = axios.create({
    baseURL: ReturnBaseUrl(), // url = base url + request url
    headers: baseHeaders,
    timeout: 8000
  })
  // http request 拦截器
  instance.interceptors.request.use(
    config => {
      prepareAuth(config)
      ///开始请求
      vm.$showLoading() ///显示加载中等待的样式
      //判断请求的参数token是否为空，取得是vuex里面的token
      console.log(config.data)
      if (config.data && config.authMode !== 'anonymous') {
        //如果data存在
        console.log(config.data.token)
        // if (config.data.token === '' || config.data.token == null) {
        // 如果data.token存在
        console.log(config.data.token)
        if (config.data.token === '' || config.data.token == null) {
          // 如果是vuex里是空的，取浏览器里面的判断  不是空就赋值
          let token = store.getters.getToken ////取token  并赋值vuex
          if (token != '') {
            config.data.token = token ////赋值请求体  的token
          }
        }
        // }
      }

      if (config.authMode === 'anonymous' && config.data) config.data.token = ''
      config.authToken = config.data && config.data.token
      return config
    },
    err => {
      ///请求超时
      console.log('超时了')
      return Promise.reject(err)
    }
  )
  // http response 拦截器
  instance.interceptors.response.use(
    response => {
      ///响应成功
      console.log('标准请求，响应成功了')
      vm.$closeLoading() ////关闭loading
      console.log(response)
      if (response.data.code === 6) {
        ///说明账号在另一台设备登录了，返回到登录页面
        console.log(1111111)
        handleExpiredSession(vm, store, response.config, response.data.message)
      }
      return response
    },
    error => {
      ///响应失败
      console.log('响应失败了')
      vm.$closeLoading() ////关闭loading

      // if (error.response) {
      //     switch (error.response.status) {
      //         case 401:
      //             // 返回 401 清除token信息并跳转到登录页面
      //             store.commit(types.LOGOUT);
      //             router.replace({
      //                 path: '',
      //                 query: { redirect: router.currentRoute.fullPath }
      //             })
      //     }
      // }
      //超时之后在这里捕抓错误信息.
      if (error.config && error.config.suppressErrorToast) {
        return Promise.reject(error.response ? error.response.data : error)
      }
      if (error.response) {
        console.log('error.response')
        console.log(error.response)
        vm.$showTips1Toast(3, error.response.status)
      } else if (error.request) {
        console.log(error.request)
        console.log('error.request')
        if (error.request.readyState == 4 && error.request.status == 0) {
          //请求超时了
          vm.$closeLoading() ////关闭loading
          vm.$showTipsToast(2, '网络开小差了')
        }
      } else {
        console.log('Error', error.message)
      }
      return Promise.reject(error.response ? error.response.data : error) // 返回接口返回的错误信息
    }
  )

  // instance.defaults.method="post"
  //返回一个实例函数，使用的是promise的方式。因为axios本身就支持promise所以返回的实例也是支持的
  ///如果需要更换网络请求框架的话，需要在返回之前包装一个promis即可
  return instance(config)
}

//不需要loading的无感请求接口
const lightRequest = config => {
  //1,创建axios实例
  const instance2 = axios.create({
    baseURL: ReturnBaseUrl(),
    headers: baseHeaders,
    timeout: 5000
  })
  // http request 拦截器
  instance2.interceptors.request.use(
    config => {
      prepareAuth(config)
      ///开始请求
      // vm.$showLoading()  ///显示加载中等待的样式

      //判断请求的参数token是否为空，取得是vuex里面的token
      console.log(config.data)
      if (config.data && config.authMode !== 'anonymous') {
        //如果data存在
        if (Object.prototype.hasOwnProperty.call(config.data, 'token')) {
          // 如果data.token存在
          console.log(config.data.token)
          if (config.data.token === '' || config.data.token == null) {
            // 如果是vuex里是空的，取浏览器里面的判断  不是空就赋值
            let token = store.getters.getToken ////取token  并赋值vuex
            if (token != '') {
              config.data.token = token ////赋值请求体  的token
            }
          }
        }
      }

      if (config.authMode === 'anonymous' && config.data) config.data.token = ''
      config.authToken = config.data && config.data.token
      return config
    },
    err => {
      ///请求超时
      console.log('超时了')
      return Promise.reject(err)
    }
  )
  // http response 拦截器
  instance2.interceptors.response.use(
    response => {
      ///响应成功

      console.log('无感请求，响应成功了')
      // vm.$closeLoading() ////关闭loading
      if (response.data.code === 6) {
        ///说明账号在另一台设备登录了，返回到登录页面
        console.log(1111111)
        handleExpiredSession(vm, store, response.config, response.data.message)
      }
      return response
    },
    error => {
      ///响应失败
      console.log('响应失败了')
      // 代号 20241212-1 不需要执行关闭 loading 的操作
      // vm.$closeLoading() ////关闭loading //

      // if (error.response) {
      //     switch (error.response.status) {
      //         case 401:
      //             // 返回 401 清除token信息并跳转到登录页面
      //             store.commit(types.LOGOUT);
      //             router.replace({
      //                 path: '',
      //                 query: { redirect: router.currentRoute.fullPath }
      //             })
      //     }
      // }
      //超时之后在这里捕抓错误信息.
      if (error.response) {
        console.log('error.response')
        console.log(error.response)
        // 代号 20241212-1 不需要执行显示窗口
        // vm.$showTips1Toast(3, error.response.status)
      } else if (error.request) {
        console.log(error.request)
        console.log('error.request')
        if (error.request.readyState == 4 && error.request.status == 0) {
          //请求超时了
          // vm.$closeLoading(); ////关闭loading
          // vm.$showTipsToast(2, "网络开小差了");
        }
      } else {
        console.log('Error', error.message)
      }
      return Promise.reject(error.response ? error.response.data : error) // 返回接口返回的错误信息
    }
  )

  // instance2.defaults.method="post"
  //返回一个实例函数，使用的是promise的方式。因为axios本身就支持promise所以返回的实例也是支持的
  ///如果需要更换网络请求框架的话，需要在返回之前包装一个promis即可
  return instance2(config)
}
/////场景规则下载专用接口 
const requestSceneRule = config => {
  //1,创建axios实例
  const instance1 = axios.create({
    baseURL: ReturnBaseUrl(),
    headers: baseHeaders
  })
  // http request 拦截器
  instance1.interceptors.request.use(
    config => {
      prepareAuth(config)
      ///开始请求     //代号 20231115-2                                                      超时时间显示
      vm.$showLoading(
        2,
        '保存并下载配置规则到本地设备中，大概需要(' +
        vm.$store.state.configinfo.requestSceneTimeout / 1000 +
        'S)请耐心等待！'
      ) ///显示加载中等待的样式s
      //判断请求的参数token是否为空，取得是vuex里面的token
      console.log(config.data)
      if (config.data && config.authMode !== 'anonymous') {
        //如果data存在
        if (Object.prototype.hasOwnProperty.call(config.data, 'token')) {
          // 如果data.token存在
          console.log(config.data.token)
          if (config.data.token === '' || config.data.token == null) {
            // 如果是vuex里是空的，取浏览器里面的判断  不是空就赋值
            let token = store.getters.getToken ////取token  并赋值vuex
            if (token != '') {
              config.data.token = token ////赋值请求体  的token
            }
          }
        }
      }

      if (config.authMode === 'anonymous' && config.data) config.data.token = ''
      config.authToken = config.data && config.data.token
      return config
    },
    err => {
      ///请求超时
      console.log('超时了')
      return Promise.reject(err)
    }
  )
  // http response 拦截器
  instance1.interceptors.response.use(
    response => {
      ///响应成功
      console.log('响应成功了')
      vm.$closeLoading() ////关闭loading
      if (response.data.code === 6) {
        ///说明账号在另一台设备登录了，返回到登录页面
        console.log(1111111)
        handleExpiredSession(vm, store, response.config, response.data.message)
      }
      return response
    },
    error => {
      ///响应失败
      console.log('响应失败了')
      vm.$closeLoading() ////关闭loading

      // if (error.response) {
      //     switch (error.response.status) {
      //         case 401:
      //             // 返回 401 清除token信息并跳转到登录页面
      //             store.commit(types.LOGOUT);
      //             router.replace({
      //                 path: '',
      //                 query: { redirect: router.currentRoute.fullPath }
      //             })
      //     }
      // }
      //超时之后在这里捕抓错误信息.
      if (error.response) {
        console.log('error.response')
        console.log(error.response)
        vm.$showTips1Toast(3, error.response.status)
      } else if (error.request) {
        console.log(error.request)
        console.log('error.request')
        if (error.request.readyState == 4 && error.request.status == 0) {
          //请求超时了
          // console.log("11111111111")
          vm.$closeLoading() ////关闭loading
          vm.$showTipsToast(2, '网络开小差了')
        }
      } else {
        console.log('Error', error.message)
      }
      return Promise.reject(error.response ? error.response.data : error) // 返回接口返回的错误信息
    }
  )

  // instance.defaults.method="post"
  //返回一个实例函数，使用的是promise的方式。因为axios本身就支持promise所以返回的实例也是支持的
  ///如果需要更换网络请求框架的话，需要在返回之前包装一个promis即可
  return instance1(config)
}

/**
 * @brief  异步的 消息id数据轮训公用接口(会先调用第一个接口,随后根据第一个接口返回的标准数据进行轮训第二个接口，直到成功或超时)
 * @param {*} params:  url: 第一个接口请求的url. data: 第一个接口请求的参数 .
 *                      customLoadingStartFn: null 使用默认 开始loading,否则使用传入的自定义 loading
 *                      customLoadingStopFn: null 使用默认 关闭loading,否则使用传入的自定义 loading
 *                      isHandStop: 默认 false ,开始API.  true 立刻停止当前轮训.
 *                      getRequestLimitsFn : 回调函数,用于返回 当前请求剩余结束次数和请求间隔,当前秒数,每秒回调一次
 * @param {*} callback: 第二个接口成功响应后的回调
 * @return {*}
 */
// 定时器变量放在外面是避免多个定时器同时启动
let isTiming = false;
let timingCurrentSec = 0;// 定时器当前的秒数
let timingCurrentCycleCount = 0; // 执行周期当前的次数
let timingCycleSec = 0; // 执行定时周期 ,单位 S
let timerHandle = null;
const asyncMessageKeyRequest = async (params, callback) => {
  const { url, data, customLoadingStartFn = null, customLoadingStopFn = null, getRequestLimitsFn = null, isHandStop = false } = params;
  // 第一个
  const getThreadNetworkInfo = () => {
    return new Promise((resolve, reject) => {
      vm.$request({
        method: "post",
        url,
        data
      }).then(res => {
        if (res.data.code != 0) {
          vm.$showTipsToast(3, res.data.message);
          resolve({});
        }
        resolve(res.data.data);
      }).catch(error => {
        console.log(error);
        reject({});
      })
    })
  }
  // 第二个
  const getRedisMessageIdData = (data) => {
    return new Promise((resolve, reject) => {
      vm.$lightRequest({
        method: "post",
        url: "/mqtt/getRedisMessageIdData",
        data: {
          token: vm.$store.state.token,
          messageKey: data.messageKey,
        },
      }).then(res => {
        if (res.data.code != 0) {
          stopUpdateTimer();
          vm.$showTipsToast(3, res.data.message);
          resolve({});
        }
        resolve(res.data);
      }).catch(error => {
        reject({});
      })
    })
  }

  // 定时器

  const timerGetUpdateResult = (data) => {
    const { timingCycle, maxTimingCycleCount } = data;
    // 启动定时器之前,先尝试关闭定定时器,避免多次启动
    stopUpdateTimer();
    if (isTiming) {
      return;
    }

    isTiming = true;
    timingCurrentSec = 0; // 定时器当前的秒数
    timingCurrentCycleCount = 0; // 执行周期当前的次数
    timingCycleSec = timingCycle / 1000; // 定时周期 ,单位 S


    console.log("当前开始轮训时间:", new Date());

    // 默认 loading 的提示文档,.使用对象的方式,可以在应用层实时更新文案的内容.
    let loadingObject =
    {
      text: '等待结果,最长(' + (timingCycleSec * maxTimingCycleCount) +
        'S),当前(' + timingCurrentSec + 'S),请耐心等待!'
    }
    if (customLoadingStartFn == null) {
      //动态文字 loading
      vm.$showLoading(
        4,
        loadingObject
      ) ///显示加载中等待的样式s
    }
    else {
      //显示自定义的等待 loading
      customLoadingStartFn(timingCurrentCycleCount, maxTimingCycleCount, timingCycleSec, timingCurrentSec);
    }


    //开始 1S 定时器, 周期调用查询异步结果
    timerHandle = setInterval(async () => {

      timingCurrentSec++;

      //   loading 更新处理
      // 默认的 loading 文案更新
      loadingObject.text = '等待结果,最长(' + (timingCycleSec * maxTimingCycleCount) +
        'S),当前(' + timingCurrentSec + 'S),请耐心等待!'


      if (getRequestLimitsFn != null) {
        // 自定义的 loading
        // 回传当前请求剩余结束次数和请求间隔 和 当前时间
        getRequestLimitsFn(timingCurrentCycleCount, maxTimingCycleCount, timingCycleSec, timingCurrentSec);
      }
      // 判断周期时间
      if (timingCurrentSec % timingCycleSec === 0) {

        timingCurrentCycleCount++;
        if (timingCurrentCycleCount > maxTimingCycleCount) {
          stopUpdateTimer();
          vm.$showTipsToast(3, "超时,结果未知~"); ////提示框
          console.log("当前结束最大时间:", new Date());
          return;
        }

        console.log("当前请求次数:", timingCurrentCycleCount,
          "最大请求次数:", maxTimingCycleCount,
          "当前秒数:", timingCurrentSec,
          "轮询请求间隔 (秒):", timingCycleSec);

        const redisMessageIdData = await getRedisMessageIdData(data);
        callback && callback(redisMessageIdData, stopUpdateTimer);
        // 再次 超时判断
        if (timingCurrentCycleCount >= maxTimingCycleCount) {
          stopUpdateTimer();
          vm.$showTipsToast(3, "超时,结果未知~"); ////提示框
          console.log("当前结束最大时间:", new Date());
          return;
        }
      }



    }, 1000);
  }

  // 停止定时器
  const stopUpdateTimer = () => {
    // 清除定时器
    if (timerHandle) {
      clearInterval(timerHandle);
      timerHandle = null;
    }
    isTiming = false;
    timingCurrentCycleCount = 0;
    timingCurrentSec = 0;
    timingCycleSec = 0;

    if (customLoadingStopFn == null) {
      // 使用默认的函数关闭loading
      vm.$closeLoading() ////关闭loading
    }
    else {
      // 使用自定义的函数关闭loading
      customLoadingStopFn();
    }
  }

  // 调用第一个接口
  if (isHandStop) {
    // 手动调用了停止
    stopUpdateTimer();
    return;
  }
  else {
    const threadNetworkInfo = await getThreadNetworkInfo();
    if (Object.keys(threadNetworkInfo).length > 0) {
      // 调用定时器
      timerGetUpdateResult(threadNetworkInfo);
    }
  }

}



///其他服务器请求
const otherRequest = config => {
  //1,创建axios实例
  const instance = axios.create({
    // baseURL: "https://api.weixin.qq.com", // url = base url + request url
    // headers:  { 'Content-Type': 'Access-Control-Allow-Origin' },
    timeout: 8000
  })
  // http request 拦截器
  instance.interceptors.request.use(
    config => {
      // if(config.headers){
      //   headers = config.headers
      // }
      ///开始请求
      vm.$showLoading() ///显示加载中等待的样式
      //判断请求的参数token是否为空，取得是vuex里面的token
      console.log(config.data)


      return config
    },
    err => {
      ///请求超时
      console.log('超时了')
      return Promise.reject(err)
    }
  )
  // http response 拦截器
  instance.interceptors.response.use(
    response => {
      ///响应成功
      console.log('标准请求，响应成功了')
      vm.$closeLoading() ////关闭loading
      console.log(response)

      return response
    },
    error => {
      ///响应失败
      console.log('响应失败了')
      vm.$closeLoading() ////关闭loading


      //超时之后在这里捕抓错误信息.
      if (error.response) {
        console.log('error.response')
        console.log(error.response)
        vm.$showTips1Toast(3, error.response.status)
      } else if (error.request) {
        console.log(error.request)
        console.log('error.request')
        if (error.request.readyState == 4 && error.request.status == 0) {
          //请求超时了
          vm.$closeLoading() ////关闭loading
          vm.$showTipsToast(2, '网络开小差了')
        }
      } else {
        console.log('Error', error.message)
      }
      return Promise.reject(error.response ? error.response.data : error) // 返回接口返回的错误信息
    }
  )

  // instance.defaults.method="post"
  //返回一个实例函数，使用的是promise的方式。因为axios本身就支持promise所以返回的实例也是支持的
  ///如果需要更换网络请求框架的话，需要在返回之前包装一个promis即可
  return instance(config)
}




/////服务器判断  返回服务器IP
const ReturnBaseUrl = () => {
  if (sessionStorage.getItem('selectServerState') === 'user') {
    console.log('返回用户设置的服务器IP')
    const server = (sessionStorage.getItem('userServeIp') || '').replace(/\/+$/, '')
    // 本机直连 smart-app 根路径；远程部署仍沿用品牌的 nginx 路径。
    let local = false
    try {
      local = ['localhost', '127.0.0.1', '[::1]'].includes(new URL(server).hostname)
    } catch (_) { /* 无效地址沿用原请求错误处理。 */ }
    return server + (local ? '' : CONFIG.servePath) + '/0/web/0'
  } else {
    console.log('返回系统设置的服务器IP')
    return remoteBaseUrl
  }
}

//获取外网IP请求的url  //代号20221222-1
const ReturnExtranetIpUrl = () => {
  let str_url = ReturnBaseUrl();
  let str_ip_url = str_url.replace(/(?:\/api)?\/0\/web\/0\/?$/, '') + '/smart/extranet/ip/';
  console.log("返回的IP请求地址:" + str_ip_url);
  return str_ip_url;
}

//获取外网IP的请求 //代号20221222-1
const extranet_ip_request = config => {
  //1,创建axios实例
  const instance = axios.create({
    baseURL: ReturnExtranetIpUrl(), // url = base url + request url
    headers: baseHeaders,
    timeout: 8000
  })
  // http request 拦截器
  instance.interceptors.request.use(
    config => {
      ///开始请求
      vm.$showLoading() ///显示加载中等待的样式
      //判断请求的参数token是否为空，取得是vuex里面的token
      // console.log(config.data)
      return config
    },
    err => {
      ///请求超时
      console.log('超时了')
      return Promise.reject(err)
    }
  )
  // http response 拦截器
  instance.interceptors.response.use(
    response => {
      ///响应成功
      console.log('获取外网IP请求，响应成功了')
      vm.$closeLoading() ////关闭loading
      console.log(response)
      let ip_str = response.data

      /* 截取有效的 IP地址返回  */
      return ip_str.substring(ip_str.indexOf("[") + 1, ip_str.indexOf("]"))
    },
    error => {
      ///响应失败
      console.log('响应失败了')
      vm.$closeLoading() ////关闭loading

      // if (error.response) {
      //     switch (error.response.status) {
      //         case 401:
      //             // 返回 401 清除token信息并跳转到登录页面
      //             store.commit(types.LOGOUT);
      //             router.replace({
      //                 path: '',
      //                 query: { redirect: router.currentRoute.fullPath }
      //             })
      //     }
      // }
      //超时之后在这里捕抓错误信息.
      if (error.response) {
        console.log('error.response')
        console.log(error.response)
        vm.$showTips1Toast(3, error.response.status)
      } else if (error.request) {
        console.log(error.request)
        console.log('error.request')
        if (error.request.readyState == 4 && error.request.status == 0) {
          //请求超时了
          vm.$closeLoading() ////关闭loading
          vm.$showTipsToast(2, '网络开小差了')
        }
      } else {
        console.log('Error', error.message)
      }
      return Promise.reject(error.response ? error.response.data : error) // 返回接口返回的错误信息
    }
  )

  // instance.defaults.method="post"
  //返回一个实例函数，使用的是promise的方式。因为axios本身就支持promise所以返回的实例也是支持的
  ///如果需要更换网络请求框架的话，需要在返回之前包装一个promis即可
  return instance(config)
}


//代号20221222-1
export { ReturnBaseUrl, request, lightRequest, requestSceneRule, otherRequest, extranet_ip_request, asyncMessageKeyRequest }

////暂时未测试以下实现的功能
// http request 拦截器
